import { Injectable } from '@angular/core';
import { LocalStorageRepository } from '../repositories/localstorage-repository';
import { IPlugin } from '../interfaces/IPlugin';
import { BehaviorSubject } from 'rxjs';

const PLUGINS: IPlugin[] = [
  {
    id: 1,
    name: "Google Drive",
    description: "Drive_descripcion",
    image: "/assets/images/plugins/google-drive.png",
    isEnabled: false,
  },
  {
    id: 2,
    name: "Gestor de archivos",
    description: "Gestor_descripcion",
    image: "/assets/images/plugins/gestor_archivos.jpg",
    isEnabled: false,
    pluginMenu: {
      id: 5500,
      text: "<div style='color: black;'>" + "Gestor de archivos" + '</div>',
      parentid: 0,
      subMenuWidth: '230px',
      value: "GESTOR_ARCHIVOS",
      textId: '',
      menuOpcionId: 5000
    }
  },
  {
    id: 3,
    name: "Visualizador WMS",
    description: "Visualizador_descripcion",
    image: "/assets/images/plugins/visualizador.jpg",
    isEnabled: false,
    pluginMenu: {
      id: 5501,
      text: "<div style='color: black;'>" + "Visualizador WMS" + '</div>',
      parentid: 0,
      subMenuWidth: '230px',
      value: "VISUALIZADOR_WMS",
      textId: '',
      menuOpcionId: 5001
    }
  }
]

@Injectable({
  providedIn: 'root'
})
export class PluginsManager {

  private pluginsRepo: LocalStorageRepository<IPlugin> = new LocalStorageRepository<IPlugin>('plugins', PLUGINS);
  private enabledPluginsSubject = new BehaviorSubject<IPlugin[]>(this.getAllActivePlugins());
  public enabledPlugins$ = this.enabledPluginsSubject.asObservable();

  public refreshPlugins(): void {
    this.pluginsRepo.fetch();
  }

  public getAllPlugins(): IPlugin[] {
    return this.pluginsRepo.getData();
  }

  public getAllActivePlugins(): IPlugin[] {
    return this.pluginsRepo.getData().filter(p => p.isEnabled);
  }

  public isPluginActive(name: string): boolean {
    const plugins = this.pluginsRepo.getData();
    const plugin = plugins.find(p => p.name === name);
    return plugin ? plugin.isEnabled : false;
  }

  public activatePlugin(name: string): void {
    const plugins = this.pluginsRepo.getData();
    const plugin = plugins.find(p => p.name === name);
    if (plugin && !plugin.isEnabled) {
      plugin.isEnabled = true;
      this.pluginsRepo.update(plugin);
      this.enabledPluginsSubject.next(this.getAllActivePlugins());
    }
  }

  public deactivatePlugin(name: string): void {
    const plugins = this.pluginsRepo.getData();
    const plugin = plugins.find(p => p.name === name);
    if (plugin && plugin.isEnabled) {
      plugin.isEnabled = false;
      this.pluginsRepo.update(plugin);
      this.enabledPluginsSubject.next(this.getAllActivePlugins());
    }
  }

  public togglePlugin(name: string): void {
    if (this.isPluginActive(name)) {
      this.deactivatePlugin(name);
    } else {
      this.activatePlugin(name);
    }
  }
}
